import { DialogType } from "@/enums/dialogType"

export default {
  namespaced: true,

  state: () => ({
    open: false,
    title: '',
    message: '',
    type: DialogType.SUCCESS,
    resolve: null
  }),

  mutations: {
    SHOW(state, payload) {
      state.title = payload.title
      state.message = payload.message
      state.type = payload.type
      state.open = true
    },

    SET_RESOLVE(state, resolve) {
      state.resolve = resolve
    },

    CLOSE(state) {
      state.open = false
      state.resolve = null
    }
  },

  actions: {
    confirm({ commit }) {
      return new Promise((resolve) => {
        commit('SET_RESOLVE', resolve)
        commit('SHOW', {
          title: 'Você deseja excluir este registro?',
          message: 'Ao confirmar, esta alteração não poderá ser desfeita.',
          type: DialogType.WARNING
        })
      })
    },

    agree({ state, commit }) {
      state.resolve(true)
      commit('CLOSE')
    },

    disagree({ state, commit }) {
      state.resolve(false)
      commit('CLOSE')
    }
  }
}
